import { WF_STATUS_WIDTH, HELP_WIDTH, STORAGE } from '@/helpers/constants';
import usersServices from '@/services/usersServices';
import {
  SET_USER_ALL, MODIFY_USER_INFO, SET_USER_STANDINS, MODIFY_USER_CONFIG,
  UPDATE_RESIZER_WF, UPDATE_RESIZER_HELP, MODIFY_SETTINGS_INFO, SET_USER_PREFERENCE, SET_STANDIN_RESALTED,
} from '../types';

const saveConfig = (newConfig) => {
  usersServices.saveUsersConfig(sessionStorage.getItem(STORAGE.USER_CODE), newConfig)
    .catch(console.error);
};

const initialState = {
  user: {},
  configuration: {
    readIntro: true,
  },
  standIns: [],
  settings: {},
  userPreferences: {},
  standInFirstTimeResalted: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_ALL:
      return {
        ...state,
        ...action.payload,
      };

    case MODIFY_USER_INFO:
      return {
        ...state,
        user: action.payload,
      };

    case SET_USER_STANDINS:
      return {
        ...state,
        standIns: action.payload,
      };

    case MODIFY_USER_CONFIG: {
      const newState = {
        ...state,
        configuration: {
          ...state.configuration,
          ...action.payload,
        },
      };
      if (action.save) saveConfig(newState.configuration);

      return newState;
    }

    case UPDATE_RESIZER_WF: {
      const newState = {
        ...state,
        configuration: {
          ...state.configuration,
          sizeSidebarLeft: action.payload,
          ...action.filtersConfig,
        },
      };

      if (action.save) saveConfig(newState.configuration);

      return newState;
    }

    case UPDATE_RESIZER_HELP: {
      const newState = {
        ...state,
        configuration: {
          ...state.configuration,
          sizeSidebarRight: action.payload,
          ...action.filtersConfig,
        },
      };
      if (action.save) saveConfig(newState.configuration);

      return newState;
    }

    case MODIFY_SETTINGS_INFO:
      return {
        ...state,
        settings: action.payload,
      };

    case SET_USER_PREFERENCE:
      return {
        ...state,
        userPreferences: action.payload,
      };

    case SET_STANDIN_RESALTED:
      return {
        ...state,
        standInFirstTimeResalted: action.payload,
      };

    default:
      return state;
  }
};

export const getUserAll = (state) => state.userReducer;
export const getUserInfo = (state) => state.userReducer.user;
export const getStandins = (state) => state.userReducer.standIns;
export const getUserSettings = (state) => state.userReducer.settings;
export const getUserConfig = (state) => state.userReducer.configuration;
export const getWFResizer = (state) => state.userReducer.configuration.sizeSidebarLeft || WF_STATUS_WIDTH.MIN;
export const getHelpResizer = (state) => state.userReducer.configuration.sizeSidebarRight || HELP_WIDTH.MAX;
export const getSettingsInfo = (state) => state.userReducer.settings;
export const getUserPreferences = (state) => state.userReducer.userPreferences;
export const getStandInFirstTimeResalted = (state) => state.userReducer.standInFirstTimeResalted;
